import React from "react";

/** Figma chevron-right — outer 16×16, leaf inset 25% / 37.5% (I4506:22988;1590:9196) */
const GrowWealthChevron = () => (
    <span className="relative inline-block size-4 shrink-0 overflow-hidden" aria-hidden>
        <span className="absolute bottom-1/4 left-[37.5%] right-[37.5%] top-[45%] h-2 w-1">
            <svg
                className="block size-full"
                viewBox="0 0 5 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0.5 8.5L4.5 4.5L0.5 0.5"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    </span>
);

export default GrowWealthChevron;
